// @flow

import * as React from "react";

type Props = {
  name: string
};

export default class Argument extends React.PureComponent<Props> {
  render() {
    return (
      <span className="cm-attribute">{this.props.name}</span>
    );
  }
}
